import { FullCalendarMonthSwitcher } from "./fullcalendarmonthswitcher.jsx"
import { FullCalendarWeekSwitcher } from "./FullCalendarWeekSwitcher.jsx"

export const FullCalendarToolbar = ({
  calendarRef,
  title,
  calendarController,
  onTodayClick
}) => {
  return (
    <div className="d-flex flex-row justify-content-between align-items-center position-relative z-3 mb-2">
      {title}
      <div className="d-flex flex-row gap-2">
        {onTodayClick && (
          <FullCalendarWeekSwitcher calendarRef={calendarRef} onTodayClick={onTodayClick} />
        )}
        <div className="d-flex flex-row flex-row-reverse">
          {calendarRef && calendarController}
        </div>
        {!onTodayClick && (
          <FullCalendarMonthSwitcher calendarRef={calendarRef} />
        )}
      </div>
    </div>
  );
};
